export type IntegrationClientsQueryParams = {
  identifier: string
  teamId: string
}

export const integrationClientsQueryKeys = {
  get: (params: { teamId: string }) => ['integration-clients', params] as const
}

export const integrationClientsMutationKeys = {
  delete: ({ identifier, ...params }: IntegrationClientsQueryParams) =>
    [`integration-clients/${identifier}`, params] as const,
  postIntegrationClientsMatchesTags: (params: { teamId: string }) =>
    ['integration-clients/matches-tags', params] as const,
  putIntegrationClientByIdentifierActivate: ({
    identifier,
    ...params
  }: IntegrationClientsQueryParams) =>
    [`integration-clients/${identifier}/activate`, params] as const
}
